module.exports = __webpack_public_path__ + "img/logo-64.10ad43d1.png";